import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { OtpModalModule } from '../otp-modal/otp-modal.module';
import { AddCardComponent } from './add-card.component';

@NgModule({
  declarations: [
      AddCardComponent
  ],
  exports:[
AddCardComponent
  ],

  imports: [
    CommonModule,
    ReactiveFormsModule,
    BrowserModule,
    FormsModule,
    OtpModalModule
  
  ],
  providers: [
   
  ],
  
})
export class AddCardModule {}
